module.exports = __webpack_public_path__ + "static/img/product_banner_09_zh.7004911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_09_zh.png
// module id = xQt9
// module chunks = 34